import {
    SCHEDULE_TASK_TYPE,
    ScheduledDatePayload,
    ScheduledTimePayload
} from "../../types";
import { useScheduleDate } from "../ScheduleDate/hooks";
import { useScheduleTime } from "../ScheduleTime/hooks";

const useScheduleTask = (
    scheduleType: SCHEDULE_TASK_TYPE | null,
    handleScheduledDate: (data: ScheduledDatePayload) => void,
    handleScheduledTime: (data: ScheduledTimePayload) => void
) => {
    const scheduleDate = useScheduleDate(scheduleType, handleScheduledDate);
    const scheduleTime = useScheduleTime(scheduleType, handleScheduledTime);

    const getScheduleForCompatibility = () => {
        if (scheduleType === null) return null;

        const from =
            scheduleType === SCHEDULE_TASK_TYPE.ByDate
                ? scheduleDate.fromDate
                : scheduleTime.fromDate;

        const to =
            scheduleType === SCHEDULE_TASK_TYPE.ByDate
                ? scheduleDate.toDate
                : scheduleTime.toDate;

        return { type: scheduleType, fromDate: from, toDate: to };
    };

    const scheduleForCompatibility = getScheduleForCompatibility();

    return {
        scheduleDate,
        scheduleTime,
        scheduleForCompatibility
    };
};

export { useScheduleTask };
